/* Native progressive enhancement; Dawn owns all commerce interactions. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('.lume-mood-tabs').forEach(list => {
      if (list.dataset.ready) return;
      list.dataset.ready = 'true';
      const tabs = [...list.querySelectorAll('[role="tab"]')];
      const activate = (tab, focus = false) => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (['ArrowDown', 'ArrowRight'].includes(event.key)) next = (index + 1) % tabs.length;
          if (['ArrowUp', 'ArrowLeft'].includes(event.key)) next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
        });
      });
    });

  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const tab = e.target.closest('[role="tab"]');
    if (tab) tab.click();
  });
  reduced.addEventListener('change', e => {
    if(e.matches) document.querySelectorAll('.lume-pending').forEach(el => el.classList.remove('lume-pending'));
  });
})();
